import { Injectable } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { NotificationModalComponent } from '../modals/notification-modal/notification-modal.component';

export type ConfirmationConstructor = 'confirm' | 'yesNo' | 'ok' | 'cancelProcess';

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	constructor(private modalService: BsModalService) {}

	public info(
		initialState: { title: string; body: string; body2?: string },
		confirmationType: ConfirmationConstructor = 'confirm',
		modalClass: string = 'pk-modal modal-lg',
	): void {
		this.modalService.show(NotificationModalComponent, {
			class: modalClass,
			backdrop: 'static',
			initialState: {
				confirmationType,
				...initialState,
			},
		});
	}

	public async confirm(
		initialState: {
			title: string;
			body: string;
			body2?: string;
			customClass?: string;
			customConfirmationButtonText?: string;
			confirmButtomClass?: string;
			cancelButtonClass?: string;
		},
		confirmationType: ConfirmationConstructor = 'confirm',
		modalClass: string = 'pk-modal modal-lg',
	): Promise<boolean> {
		return new Promise((resolve, reject) => {
			try {
				let returnValue = false;
				const modalRef = this.modalService.show(NotificationModalComponent, {
					class: modalClass,
					backdrop: 'static',
					initialState: {
						confirmationType,
						...initialState,
					},
				});
				modalRef.content.onConfirm.subscribe(() => {
					returnValue = true;
				});
				modalRef.content.onCancel.subscribe(() => {
					returnValue = false;
				});
				modalRef.onHidden.subscribe(() => {
					resolve(returnValue);
				});
			} catch (e) {
				reject(e.message);
			}
		});
	}
}
